import { motion } from "framer-motion";

export const LogoMark = ({ size = 40, animated = false }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
    >
        <defs>
            <linearGradient id="zx-g" x1="0" y1="0" x2="48" y2="48">
                <stop offset="0%" stopColor="#66B5FF" />
                <stop offset="100%" stopColor="#0080FF" />
            </linearGradient>
        </defs>
        <motion.path
            d="M8 12 H32 L16 36 H40"
            stroke="url(#zx-g)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={animated ? { pathLength: 0.05 } : false}
            animate={animated ? { pathLength: 1 } : undefined}
            transition={animated ? { duration: 1.25, ease: [0.65, 0, 0.35, 1] } : undefined}
        />
        <motion.path
            d="M31 5 L41 15 M41 5 L31 15"
            stroke="#0080FF"
            strokeWidth="3"
            strokeLinecap="round"
            initial={animated ? { pathLength: 0, opacity: 0 } : false}
            animate={animated ? { pathLength: 1, opacity: 1 } : undefined}
            transition={animated ? { delay: 0.65, duration: 0.6, ease: "easeOut" } : undefined}
        />
    </svg>
);

export const LogoFull = ({ size = 34, className = "" }) => (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="zenithix-logo">
        <LogoMark size={size} />
        <span className="font-display text-base font-semibold tracking-[0.18em] text-ice">
            ZENITH<span className="text-electric">IX</span>
        </span>
    </span>
);
